import { createAppByPlatform } from '@/create-app/createAppHg';

import { initDatadogRUM } from '@/helpers/datadogRUMService';
import App from './AppHg.vue';

(async () => {
  const { app, router, pinia } = await createAppByPlatform(App);

  initDatadogRUM();

  const initialState = window.__INITIAL_STATE__;
  if (initialState) {
    pinia.state.value = initialState;
  }

  await router.isReady();
  app.mount('#app');
})();
